<template>
  <div>
    <el-dialog width="30%" title="提示" :show-close="false" :close-on-click-modal=false  v-model="confirmBool" draggable>
      <span style="font-size: 20px">【{{wujianId}}物件】进行了排产，您是否保存？</span>
      <div style="width: 100%;display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top: 40px;">
        <el-button type="primary" :loading="cancelLoading" style="width: 100px;" @click="cancelEvent()">取消</el-button>
        <el-button type="primary" :loading="confirmLoading" style="width: 100px;" @click="confirmEvent()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PaintingDialog",
  props: {
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return {
      confirmBool: true,
      cancelLoading: false,
      confirmLoading: false,
      wujianId: JSON.parse(localStorage.getItem("paintingWujianId")),
    }
  },methods: {
    cancelEvent() {
      this.confirmBool = false;
      this.deletePaintingSaveStatus();
      this.setting.$fn.closeWindow();
    },
    confirmEvent() {
      this.confirmBool = false;
      this.saveAllDate();
      this.setting.$fn.closeWindow();
    },
    deletePaintingSaveStatus(){
      this.cancelLoading = true;
      let params = this.parentData;
      console.log("params==",params)
      this.$axios.post('mfg/paintingProduction/deletePaintingSaveStatus', params).then(response => {
        this.cancelLoading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        localStorage.removeItem("paintingWujianId")
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    saveAllDate() {
      this.confirmLoading = true;
      let params = {startTime: this.parentData.startTime, endTime: this.parentData.endTime, wujian_id: this.parentData.thing}
      console.log("params==",params)
      this.$axios.post('mfg/paintingProduction/saveAllDate', params).then(response => {
        this.confirmLoading = false;
        let res = response.data
        if (res.code !== 0){
          return this.$message.error(res.message);
        }
        localStorage.removeItem("paintingWujianId")
        return this.$message.success("保存成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
  }
}
</script>

<style scoped>

</style>